// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"61":"b202ca56","273":"dece118c","513":"86616375","544":"0a41916b","619":"5217d108","851":"b202ca56","882":"07e63609"}[chunkId] + ".chunk.css";
};